import { Component } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { CellData } from '@ddt-web/data-service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as isEmpty from 'lodash/isEmpty';

@Component({
	selector: 'ac-ishares-cell-renderer',
	templateUrl: './ishares-cell-renderer.component.html',
	styleUrls: ['./ishares-cell-renderer.component.scss']
})
export class ISharesCellRendererComponent implements ICellRendererAngularComp {
	public data: CellData;
	public params: any;
	public isEmpty = isEmpty;

	constructor(private hrefResolverService: HrefResolverService) { }

	public agInit(params: any): void {
		this.params = params;
		this.refresh();
	}

	public refresh(): boolean {
		this.data = this.params['value'];
		return false;
	}
}
